export const pokemonReducer = (state, action) => {
    switch (action.type) {
        case 'POPULATE_POKEMONS':
            return action.pokemons;
        default:
            return [];
    }
}

export const filterReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter
            };
        case 'SET_COUNT':
            return {
                ...state,
                count: action.count
            };
        default:
            return '';
    }
}

export const pokemonDataReducer = (state, action) => {
    switch (action.type) {
        case 'POKEMON_DATA':
            return {
                ...state,
                ...action.pokemon
            }
        default:
            return {};
    }
}